module.exports = __webpack_public_path__ + "static/img/3.ff5a8f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresariales-Multirriesgo-Copropiedades/3.png
// module id = 3nTO
// module chunks = 0